import Cyber from './Cyber';

export default Cyber;
